import React from 'react';
import { motion } from 'framer-motion';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  children: React.ReactNode;
  className?: string;
  onClick?: () => void;
}
export function Button({
  children,
  className = '',
  onClick,
  ...props
}: ButtonProps) {
  const scrollToOffer = () => {
    if (onClick) {
      onClick();
      return;
    }
    const offerSection = document.getElementById('oferta');
    if (offerSection) {
      offerSection.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return <motion.button whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} animate={{
    boxShadow: ['0px 0px 0px 0px rgba(220, 38, 38, 0.4)', '0px 0px 20px 10px rgba(220, 38, 38, 0.2)', '0px 0px 0px 0px rgba(220, 38, 38, 0.4)']
  }} transition={{
    duration: 2,
    repeat: Infinity,
    ease: 'easeInOut'
  }} onClick={scrollToOffer} className={`bg-brand-red hover:bg-brand-redHover text-white font-oswald uppercase text-xl md:text-2xl font-bold py-5 px-8 md:px-12 rounded-lg shadow-lg shadow-brand-red/20 transition-colors w-full max-w-2xl mx-auto flex items-center justify-center gap-3 ${className}`} {...props} data-id="element-267">
      {children}
    </motion.button>;
}